<template>
  <el-dialog :visible.sync="visible" :title="'活动教师设置'" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">
    <div class="mod-club__clubTeacher">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.teacherName" placeholder="姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="teacherName" label="教师名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="teacherSex" label="性别" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.teacherSex === sexual.MAN">男</el-tag>
            <el-tag v-else-if="scope.row.teacherSex === sexual.WOMAN">女</el-tag>
          </template>
        </el-table-column>
        <el-table-column  header-align="center" align="center" >
          <template slot-scope="scope">
            <el-button v-if="isInArray(scope.row)" size="mini" @click="addCheckedTeachers(scope.row)">选中</el-button>
            <el-button v-else=""  type="danger" size="mini" @click="removeCheckedTeachers(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="pageSizeChangeHandle"
              @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { sexual, teacherType } from '../../../constant'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/teacher/teacher/activityPageList',
        getDataListIsPage: true
      },
      checkedTeachersList: [],
      checkedTeachersNameList: [],
      visible: false,
      teacherType,
      sexual,
      dataForm: {
        teacherName: '',
        clubCourseId: ''
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.query()
    },
    addCheckedTeachers (row) {
      this.checkedTeachersList.push(row.id)
      this.checkedTeachersNameList.push(row.teacherName)
      this.$emit('checkedTeachers', [this.checkedTeachersList, this.checkedTeachersNameList])
    },
    removeCheckedTeachers (row) {
      for (let i = 0; i < this.checkedTeachersList.length; i++) {
        if (this.checkedTeachersList[i] === row.id) {
          this.checkedTeachersList.splice(i, 1)
        }
      }
      for (let i = 0; i < this.checkedTeachersNameList.length; i++) {
        if (this.checkedTeachersNameList[i] === row.teacherName) {
          this.checkedTeachersNameList.splice(i, 1)
        }
      }
      this.$emit('checkedTeachers', [this.checkedTeachersList, this.checkedTeachersNameList])
    },
    isInArray (row) {
      for (var i = 0; i < this.dataList.length; i++) {
        if (row.id === this.checkedTeachersList[i]) {
          return false
        }
      }
      return true
    }
  },
  components: {
  }
}
</script>
